import React from 'react';
import IconRadiusButton from './IconRadiusButton';
import ArrowLeft from '../assets/icons/white-arrow-left.png'

export default function GoBackButton({ color, ...props }) {
    return (
        <IconRadiusButton {...props}>
            <img
                src={ArrowLeft}
                style={{ width: "14.9px", height: "14.8px" }}
            />
        </IconRadiusButton>
    );
}
